{
  "language": {
    "en": "English",
    "zh": "中文"
  },
  "heroTitle": "Subscribe today for full E-paper access and a 14-day archive",
  "heroSubtitle": "Read it your way: switch seamlessly between the classic print-style layout and a mobile-friendly HTML article view.",
  "or": "or",
  "singleCopyTitle": "Read today's E-paper, no strings attached.",
  "singleCopySubtitle": "Buy a single copy instantly - no recurring charges, no long-term commitment.",
  "buyToday": "Buy today's E-paper",
  "publications": {
    "st": "The Straits Times",
    "zb": "Lianhe Zaobao",
    "sm": "Shin Min Daily News",
    "tm": "Tamil Murasu",
    "bt": "The Business Times",
    "bh": "Berita Harian"
  },
  "links": {
    "buyToday": "https://subscribe.sph.com.sg/pages/epaper/buy?utm_campaign=singlecopyepaper&utm_medium=sph-publication&utm_source=epaperlp&utm_content=purchaselink-epaperlp-singlecopy",
    "publications": {
      "st": "https://subscribe.sph.com.sg/publications-st?utm_campaign=st_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-st",
      "zb": "https://subscribe.sph.com.sg/publications-zb?utm_campaign=zb_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-zb",
      "sm": "https://subscribe.sph.com.sg/publications-sm?utm_campaign=sm_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-sm",
      "tm": "https://subscribe.sph.com.sg/publications-tm?utm_campaign=tm_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-tm",
      "bt": "https://subscribe.sph.com.sg/publications-bt?utm_campaign=bt_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-bt",
      "bh": "https://subscribe.sph.com.sg/publications-bh?utm_campaign=bh_subscription&utm_medium=sph-publication&utm_source=epaperlp&utm_content=subscribebutton-epaperlp-bh"
    }
  },
  "footer": {
    "about": "About Us",
    "promotions": "Promotions",
    "subscriptionTerms": "Standard Subscription Terms and Conditions",
    "termsConditions": "Terms and Conditions",
    "cookieNotice": "Cookie Notice",
    "personalDataProtection": "Personal Data Protection Notice",
    "officialDomains": "Official Domains",
    "contactUs": "Contact Us",
    "onlineForm": "Online form",
    "generalEnquiries": "General enquiries:",
    "corporateEnquiries": "Corporate enquiries:",
    "copyright": "Copyright © {{year}} SPH Media Limited. Co. Regn. No. 202120748H. All Rights Reserved.",
    "address": "1000 Toa Payoh North Annexe Level 6, News Centre Singapore 318994"
  },
  "footerLinks": {
    "promotions": "https://subscribe.sph.com.sg/promotions-listing/",
    "subscriptionTerms": "https://subscribe.sph.com.sg/tnc/standard/",
    "termsConditions": "https://www.sph.com.sg/legal/website_tnc/",
    "cookieNotice": "https://www.sph.com.sg/tnc/cookie/",
    "personalDataProtection": "https://www.sph.com.sg/tnc/pdpa/",
    "officialDomains": "https://www.sph.com.sg/officialdomains/",
    "onlineForm": "https://subscribe.sph.com.sg/contact-us/"
  }
}
